import { Component, OnInit } from '@angular/core';
import { ProvidersService } from 'src/app/services/providers.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ProviderItemInputs } from 'src/app/models/provider-item-inputs';
import { HttpErrorResponse } from '@angular/common/http';
import { ProviderDetails } from 'src/app/models/provider-details';
import {checkFormat} from '../../util/tools';
import {STRING_IS_INTEGER} from '../../util/constants';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

  public guid: string;
  constructor(public providersService: ProvidersService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.guid = params.id;
    });
    this.setValuesFromQueryParams();
  }

  /// http://localhost:4200/redirect/06B9FD02-032D-4956-A0A3-A2ED9352C409?v3=1660010196100100&a=1000
  public setValuesFromQueryParams(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      const items: ProviderItemInputs[] = [];
      let amount;
      for (const [key, value] of Object.entries(params)) {
        const providerId = key;
        if (providerId.charAt(0) === 'v') {
          items.push(new ProviderItemInputs(providerId.substring(1), value));
        } else if (key === 'a'){
            amount = value;
        } else {
          this.router.navigate([`notfound`]);
        }
      }
      if (items.length > 0) {
        this.checkProviderItemInputs(items, amount);
      } else {
        this.router.navigate([`notfound`]);
      }
    });
  }

  public checkProviderItemInputs(items: ProviderItemInputs[], amount: string) {
    this.providersService.checkProviderItemInputs(items).subscribe(response => {
      if (response instanceof HttpErrorResponse || response.Status === 400) {
        this.router.navigate([`notfound`]);
      }
      else {
        if (amount && !checkFormat(amount, STRING_IS_INTEGER)){
          this.router.navigate([`pay/${this.guid}?${amount}`]);
        } else {
          this.router.navigate([`pay/${this.guid}`]);
        }
      }
    });
  }

}
